"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ConfirmCyclicalReportModal = _interopRequireDefault(require("./ConfirmCyclicalReportModal"));
var _modalDecorator = _interopRequireDefault(require("../../../hocs/modalDecorator"));
var _modalActions = require("../../../redux/actions/modalActions");
var _reportActions = require("../../../redux/actions/reportActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = {
  scheduleReport: _reportActions.scheduleReport
};
var container = (0, _reactRedux.connect)(null, mapDispatchToProps)(_ConfirmCyclicalReportModal["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.CONFIRM_CYCLICAL_REPORT
})(container);